import { render, staticRenderFns } from "./PayPalCasesEditingSection.vue?vue&type=template&id=5db684f8"
import script from "./PayPalCasesEditingSection.vue?vue&type=script&lang=js"
export * from "./PayPalCasesEditingSection.vue?vue&type=script&lang=js"
import style0 from "./PayPalCasesEditingSection.vue?vue&type=style&index=0&id=5db684f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports